import React from 'react';
import PropTypes from 'prop-types';
import { navigateTo } from 'gatsby-link';

class InternalLink extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }

  onClick(event) {
    event.preventDefault();
    this.props.onClick();
    navigateTo(`/#${this.props.slug}`);
  }

  onKeyUp(event) {
    if (event.keyCode === 13) {
      this.onClick(event);
    }
  }

  render() {
    const { children, slug } = this.props;
    return (
      <a
        href={`/${slug}`}
        onClick={this.onClick}
        tabIndex={-1}
        onKeyUp={this.onKeyUp}
      >
        {children}
      </a>
    );
  }
}

InternalLink.propTypes = {
  slug: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  onClick: PropTypes.func,
};

InternalLink.defaultProps = {
  onClick: () => null,
};

export default InternalLink;



// WEBPACK FOOTER //
// ./src/components/InternalLink/index.js